<template>
  <moe-page>
    <moe-top ref="moeTop"></moe-top>
    <div class="exam_paper_view flex Flexjustify">
      <div class="exam_paper_content flex FlexBetween">
        <div class="exam_paper_info">
          <div class="exam_paper_info_top">
            <div class="exam_paper_title flex FlexBetween">
              <div>{{ examinationInfo.paperDocumentName }}</div>
              <div class="flex Flexalign cursor_pointer" @click="back()">
                <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
                <div class="back_text">返回</div>
              </div>
            </div>
            <div class="flex Flexalign FlexBetween exam_paper_data_total mt-10 mb-20">
              <div class="exam_paper_data flex Flexalign" v-if="!isRandom">
                <div class="data_one flex Flexalign">
                  <el-image class="release_icon" :src="iconPath('release_icon.png')"></el-image>
                  <div class="ml-5">
                    发布时间：{{ examinationInfo.createTime?.split(" ")[0] }}
                  </div>
                </div>
                <div class="data_one flex Flexalign ml-20">
                  <el-image class="release_icon" :src="iconPath('view_icon.png')"></el-image>
                  <div class="ml-5">浏览量：{{ examinationInfo.viewCount }}</div>
                </div>
                <div class="data_one flex Flexalign ml-20">
                  <el-image class="release_icon" :src="iconPath('download_paper_icon.png')"></el-image>
                  <div class="ml-5">下载量：{{ examinationInfo.downloadCount }}</div>
                </div>
                <div class="data_one flex Flexalign ml-20">
                  <el-image class="release_icon" :src="iconPath('paper_type_icon.png')"></el-image>
                  <div class="ml-5">类型：{{ examinationInfo.paperTypeName }}</div>
                </div>
                <div class="data_one flex Flexalign ml-20 cursor_pointer" @mouseenter="showMoreInfo"
                  @mouseleave="hideMoreInfo">
                  <div class="">更多</div>
                  <el-image class="release_icon ml-5" :src="iconPath('more_icon.png')"></el-image>
                  <div class="more_box p-10" v-if="showMoreFlag">
                    <div class="">创建人：{{ examinationInfo.createByName }}</div>
                    <div class="mt-5">试卷难度</div>
                    <el-rate v-model="examinationInfo.difficulty" disabled :max="7" size="small" />
                  </div>
                </div>
              </div>
              <div class="flex Flexalign exam_paper_collect cursor_pointer">
                <el-image class="release_icon" :src="iconPath(
                  examinationInfo.isCollection
                    ? 'collect_acitve_green.png'
                    : 'collect_green.png'
                )
                  "></el-image>
                <div class="ml-5" @click="collectPaper">
                  {{ examinationInfo.isCollection ? "取消收藏" : "收藏试卷" }}
                </div>
              </div>
            </div>
          </div>
          <!-- 文件预览区域 -->
          <div class="file-preview-container mt-20" v-if="previewUrl">
            <div class="preview-header flex FlexBetween Flexalign mb-10">
              <div class="preview-title">试卷预览</div>
              <!-- <div class="flex Flexalign">
                                <div v-if="!canPreviewFull" class="preview-action cursor_pointer mr-10"
                                    @click="handlePreviewAction">
                                    <el-image class="download-icon" :src="iconPath('buy_icon.png')"></el-image>
                                    <span class="ml-5">{{ previewActionText }}</span>
                                </div>
                                <div v-else class="preview-action cursor_pointer mr-10" @click="downloadCurrentFile">
                                    <el-image class="download-icon" :src="iconPath('download_icon.png')"></el-image>
                                    <span class="ml-5">下载</span>
                                </div>
                            </div> -->
            </div>

            <!-- PDF预览 -->
            <div class="pdf-preview" v-if="downloadPapams.format === 'pdf'">
              <!-- 蒙版层（未购买时显示） -->
              <div class="preview-mask" v-if="!canPreviewFull">
                <div class="mask-content">
                  <!-- <el-image class="lock-icon" :src="iconPath('lock_icon.png')"></el-image> -->
                  <div class="mask-title mt-10">完整内容已锁定</div>
                  <div class="mask-desc mt-5">购买后即可查看完整试卷内容</div>
                  <div class="mask-action mt-15" @click="handlePreviewAction">
                    {{ previewActionText }}
                  </div>
                </div>
              </div>

              <!-- 半透明遮罩（只显示部分内容） -->
              <div class="partial-preview" v-if="!canPreviewFull">
                <iframe :src="previewUrl" class="pdf-viewer partial" frameborder="0"></iframe>
                <div class="preview-overlay"></div>
              </div>

              <!-- 完整预览（已购买） -->
              <iframe v-else :src="previewUrl" class="pdf-viewer full" :class="{ fullscreen: isFullScreen }"
                frameborder="0"></iframe>
            </div>

            <!-- Word文档预览 -->
            <div class="word-preview" v-else-if="downloadPapams.format === 'word'">
              <!-- 蒙版层（未购买时显示） -->
              <div class="preview-mask" v-if="!canPreviewFull">
                <div class="mask-content">
                  <!-- <el-image class="lock-icon" :src="iconPath('lock_icon.png')"></el-image> -->
                  <div class="mask-title mt-10">完整内容已锁定</div>
                  <div class="mask-desc mt-5">购买后即可查看完整Word文档</div>
                  <div class="mask-action mt-15" @click="handlePreviewAction">
                    {{ previewActionText }}
                  </div>
                </div>
              </div>

              <!-- 部分预览 -->
              <div class="partial-preview" v-if="!canPreviewFull">
                <div class="preview-placeholder">
                  <div class="placeholder-header">
                    <div class="placeholder-line"></div>
                    <div class="placeholder-line short"></div>
                  </div>
                  <div class="placeholder-content">
                    <div class="placeholder-text" v-for="i in 5" :key="i"></div>
                  </div>
                  <div class="placeholder-footer">
                    <div class="placeholder-line"></div>
                    <div class="placeholder-line"></div>
                  </div>
                </div>
                <div class="preview-overlay"></div>
              </div>

              <!-- 完整预览（已购买） -->
              <iframe v-else :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                previewUrl
              )}`" class="word-viewer full" :class="{ fullscreen: isFullScreen }" frameborder="0"></iframe>
            </div>

            <!-- 其他格式预览 -->
            <div class="image-preview" v-else>
              <!-- 图片预览的蒙版 -->
              <div class="preview-mask" v-if="!canPreviewFull">
                <div class="mask-content">
                  <!-- <el-image class="lock-icon" :src="iconPath('lock_icon.png')"></el-image> -->
                  <div class="mask-title mt-10">完整内容已锁定</div>
                  <div class="mask-desc mt-5">购买后即可查看完整文件</div>
                  <div class="mask-action mt-15" @click="handlePreviewAction">
                    {{ previewActionText }}
                  </div>
                </div>
              </div>

              <img :src="previewUrl" class="preview-image" :class="{ blurred: !canPreviewFull }" alt="文件预览" />
            </div>
          </div>

          <!-- 加载状态 -->
          <div class="loading-container mt-20" v-else-if="loading">
            <div class="flex Flexalign Flexjustify flexcolumn">
              <el-icon class="is-loading" size="30">
                <Loading />
              </el-icon>
              <div class="mt-10">正在加载试卷...</div>
            </div>
          </div>

          <!-- 预览提示 -->
          <div class="preview-tip mt-20" v-else>
            <div class="tip-content flex Flexalign">
              <el-image class="tip-icon" :src="iconPath('tip_icon.png')"></el-image>
              <div class="ml-10">点击下方按钮下载试卷文件</div>
            </div>
          </div>
        </div>
        <div class="paper_right">
          <!-- <div class="btn_buy cursor_pointer" v-if="examinationInfo.feeType == 1">立即下载</div> -->
          <div class="btn_buy cursor_pointer flex FlexEnd Flexjustify"
            v-if="examinationInfo.feeType == 2 && !examinationInfo.isBuy" @click="payOrder">
            <div>￥</div>
            <div class="paper_price">{{ examinationInfo.price }}</div>
            <div class="ml-15">立即购买</div>
          </div>
          <div class="flex FlexBetween btn_box" v-if="examinationInfo.feeType == 1 || examinationInfo.isBuy">
            <div class="btn_exam cursor_pointer" @click="onlineExam">在线考试</div>
            <div class="btn_exam cursor_pointer btn_download" @click="downloadCurrentFileNew">
              试卷下载
            </div>
          </div>
          <div class="paper_answer_card mt-20">
            <paperAnswerSheet :testExamInfo="paperInfo"></paperAnswerSheet>
          </div>
          <div class="mt-20 recommend_paper py-20 px-15">
            <div class="recommend_one mb-10 flex Flexalign FlexBetween cursor_pointer"
              v-for="(item, index) in recommendPaperList" :key="index" @click="viewExamPaper(item)">
              <el-image class="test_paper_cover_icon" :src="iconPath('test_paper_cover_icon.svg')"></el-image>
              <div class="recommend_info toverflow ml-5 flex-1 flex flexcolumn FlexBetween">
                <div class="recommend_title toverflow">{{ item.paperDocumentName }}</div>
                <div class="flex recommend_info_content">
                  <div>{{ $Moment(item.updateTime).format("MM-DD") }}发布</div>
                  <div class="ml-10">下载量：{{ item.downloadCount }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <downloadPaper :paperInfo="paperInfo" :examinationInfo="examinationInfo" ref="downloadPaper"></downloadPaper>
    <examinationPaperDownload ref="examinationPaperDownload" :examinationInfo="examinationInfo" :paperInfo="paperInfo"
      @order-paid="handleOrderPaid"></examinationPaperDownload>
    <moe-bottom></moe-bottom>
  </moe-page>
</template>

<script>
import paperAnswerSheet from "@/components/exam/paperAnswerSheet.vue";
import * as Cache from "@/assets/utils/cache";
import axios from "axios";
import * as Config from "@/config/config";
import downloadPaper from "@/components/popup/downloadPaper.vue";
import examinationPaperDownload from "@/components/popup/examinationPaperDownload.vue";
import { Loading } from "@element-plus/icons-vue";
export default {
  name: "GjkcH5ExamPaperView",
  components: {
    paperAnswerSheet,
    Loading,
    downloadPaper,
    examinationPaperDownload,
  },

  data() {
    return {
      paperDocumentId: "",
      examinationInfo: {},
      showMoreFlag: false,
      paperInfo: {},
      downloadPapams: {
        paperId: "",
        format: "pdf",
        includeAnswer: false,
        includeAnalysis: false,
        includeExplanation: false,
        answerPosition: "end",
        isDownload: false, // 是否统计下载次数
      },
      listParams: {
        year: "", // 年份
        feeType: "",
        stageId: "",
        gradeId: "",
        subjectId: "",
        difficulty: "",
        phaseId: "",
        roundId: "",
        page: 1,
        pageSize: 5,
        sort: 3,
        paperTypeId: "",
      },
      recommendPaperList: [],
      previewUrl: null, // 预览URL
      currentBlob: null, // 当前Blob对象
      loading: false, // 加载状态
      isFullScreen: false, // 全屏状态
      previewMode: "partial", // 'partial' 或 'full'
      isRandom: false,
      loadPaper: {},
    };
  },

  computed: {
    // 是否可以预览完整内容
    canPreviewFull() {
      // 如果已购买或者是免费试卷，可以预览完整内容
      return this.examinationInfo.isBuy || this.examinationInfo.feeType == 1;
    },

    // 预览操作按钮文本
    previewActionText() {
      if (this.examinationInfo.feeType == 1) {
        return "免费下载";
      } else if (this.examinationInfo.feeType == 2 && !this.examinationInfo.isBuy) {
        return `￥${this.examinationInfo.price} 立即购买`;
      } else {
        return "立即下载";
      }
    },
  },
  // 在现有的 `mounted()` 方法附近，添加 `watch` 监听
  watch: {
    // 方法1：直接深度监听 $route 变化（最可靠）
    $route: {
      handler() {
        // 直接提取新参数
        const newPaperId = this.$Jump.getUrlParams(window.location.hash.split("?")[1])
          .paperDocumentId;
        const oldPaperId = this.paperDocumentId;

        // 只有参数确实变化时才刷新
        if (newPaperId && newPaperId !== oldPaperId) {
          console.log("检测到试卷ID变化:", oldPaperId, "->", newPaperId);
          this.paperDocumentId = newPaperId;

          // 清理旧数据
          this.cleanupPreviousPaper();

          // 重新获取数据
          this.refreshPaperData();
        }
      },
      immediate: false, // 立即执行一次，确保初始状态正确
      deep: true, // 深度监听
    },

    // 方法2：或者单独监听 paperDocumentId（更精确）
    paperDocumentId: {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          console.log("paperDocumentId 变化:", oldId, "->", newId);
          this.cleanupPreviousPaper();
          this.refreshPaperData();
        }
      },
      immediate: false,
    },
    "examinationInfo.isBuy": {
      handler(newVal) {
        if (newVal === true) {
          console.log("试卷已购买，可以加载完整预览");
          // 如果需要自动刷新预览，可以在这里调用
          // this.loadPaperForPreview();
        }
      },
      immediate: false,
    },
  },

  mounted() {
    this.paperDocumentId = this.$Jump.getUrlParams(
      window.location.hash.split("?")[1]
    ).paperDocumentId;
    this.isRandom = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).isRandom;
    this.getExaminationInfo();
    this.getExaminationList();
  },

  beforeUnmount() {
    this.revokePreviewUrl();
  },
  provide() {
    return {
      refreshPaperInfo: this.refreshPaperInfo, // 提供刷新方法
      paperDocumentId: this.paperDocumentId, // 可以提供需要的参数
    };
  },

  methods: {
    // 新增：清理上一份试卷数据
    cleanupPreviousPaper() {
      this.revokePreviewUrl();
      this.previewUrl = null;
      this.currentBlob = null;
      this.loading = false;
      this.examinationInfo = {};
      this.paperInfo = {};
    },

    // 新增：刷新试卷数据的统一方法
    refreshPaperData() {
      this.getExaminationInfo();
      this.getExaminationList();
    },
    // 查看试卷
    viewExamPaper(info) {
      this.href("/examPaperView", { paperDocumentId: info.paperDocumentId });
    },
    // 获取试卷列表
    getExaminationList() {
      this.$Api.examination
        .getExaminationList(this.listParams)
        .then((res) => {
          this.recommendPaperList = res.data.data?.list;
        })
        .catch(() => { });
    },
    downloadCurrentFileNew() {
      // this.$refs.downloadPaper.downloadPaperShow = true;
      this.$refs.examinationPaperDownload.examinationPaperDownloadShow = true;
    },
    // 处理订单支付成功
    async handleOrderPaid(data) {
      console.log("订单支付成功:", data);

      try {
        // 方式1：重新获取试卷信息
        await this.refreshPaperInfo();

        // 方式2：如果支付后试卷已购买，可以更新本地状态
        this.examinationInfo.isBuy = true;

        // 可选：重新加载试卷预览（如果有权限了）
        if (this.previewUrl) {
          // 刷新预览（可能需要重新下载完整版）
          await this.loadPaperForPreview();
        }

        this.$message.success("支付成功，已刷新试卷信息");
      } catch (error) {
        console.error("刷新试卷信息失败:", error);
      }
    },

    // 刷新试卷信息
    async refreshPaperInfo() {
      if (!this.paperDocumentId) return;

      try {
        let res = {}
        if (this.isRandom) {
          res = await this.$Api.examination.getRandomPaperDocument(
            this.paperDocumentId
          );
        } else {
          res = await this.$Api.examination.getExaminationInfo(
            this.paperDocumentId
          );
        }
        if (res.data && res.data.data) {
          // 更新试卷信息
          this.examinationInfo = res.data.data;

          // 如果之前没有试卷内容，可能需要重新获取
          if (!this.paperInfo || Object.keys(this.paperInfo).length === 0) {
            await this.getExamPaperInfo(res.data.data.paperId);
          }

          console.log("试卷信息已刷新");
        }
      } catch (error) {
        console.error("刷新试卷信息失败:", error);
        throw error;
      }
    },

    // 重写payOrder方法，改为打开弹窗
    payOrder() {
      this.$refs.examinationPaperDownload.examinationPaperDownloadShow = true;
    },
    // 去购买
    // payOrder() {
    //     // this.$Jump.href("/examPaperOrderConfirm", { paperDocumentId: this.paperDocumentId });
    //     this.$refs.examinationPaperDownload.examinationPaperDownloadShow = true;
    // },
    showMoreInfo() {
      this.showMoreFlag = true;
    },
    hideMoreInfo() {
      this.showMoreFlag = false;
    },
    // 处理预览操作（购买/下载）
    handlePreviewAction() {
      if (this.examinationInfo.feeType == 1) {
        // 免费试卷，直接下载
        this.downloadCurrentFile();
      } else if (this.examinationInfo.feeType == 2 && !this.examinationInfo.isBuy) {
        // 付费试卷，去购买
        this.payOrder();
      } else {
        // 已购买，直接下载
        this.downloadCurrentFile();
      }
    },

    // 下载试卷文件并创建预览
    async downloadPaperForPreview() {
      this.downloadPapams.paperId = this.examinationInfo.paperId;
      const token = Cache.get("token");

      // 先清理之前的预览URL
      this.revokePreviewUrl();

      try {
        const response = await axios.post(
          Config.API_BASE_URL + "/yymCourseQuestionExamPaper/download",
          this.downloadPapams,
          {
            responseType: "blob",
            headers: {
              Authorization: `${token}`,
              "Content-Type": "application/json",
            },
            timeout: 30000,
          }
        );

        if (response.data instanceof Blob) {
          const blob = response.data;
          this.currentBlob = blob;

          console.log(`文件大小: ${blob.size} 字节`);
          console.log(`文件类型: ${blob.type}`);

          // 检查文件类型是否正确
          if (blob.type === 'application/pdf') {
            console.log('PDF文件，可以正常预览');
          } else if (blob.type.includes('json')) {
            // 如果返回的是JSON错误信息
            const text = await blob.text();
            try {
              const errorData = JSON.parse(text);
              console.error('服务器返回错误:', errorData);
              this.$Dialog.toast(errorData.message || '加载失败');
              return;
            } catch {
              // 不是JSON，继续处理
            }
          }

          // 创建预览URL
          this.createPreviewUrl(blob);
        } else {
          throw new Error("返回的数据不是Blob格式");
        }

        return response;
      } catch (error) {
        console.error("下载失败:", error);

        // 尝试解析错误信息
        if (error.response && error.response.data instanceof Blob) {
          const errorText = await error.response.data.text();
          try {
            const errorJson = JSON.parse(errorText);
            this.$Dialog.toast(errorJson.message || "加载预览失败");
          } catch {
            this.$Dialog.toast("加载预览失败，请检查网络或权限");
          }
        } else {
          this.$Dialog.toast("加载预览失败，请检查网络连接");
        }

        throw error;
      }
    },

    // 创建预览URL - 修复版
    createPreviewUrl(blob) {
      // 清理之前的URL
      this.revokePreviewUrl();

      // 直接使用 createObjectURL，而不是 FileReader
      // createObjectURL 更高效，没有大小限制
      const url = window.URL.createObjectURL(blob);

      // 对于 PDF，可以添加参数控制工具栏显示
      this.previewUrl = url + '#toolbar=0&navpanes=0';
    },

    // 清理预览URL
    revokePreviewUrl() {
      if (this.previewUrl) {
        window.URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
    },

    // 下载当前预览的文件
    downloadCurrentFile() {
      if (!this.currentBlob) {
        this.$Dialog.toast("请先加载试卷");
        return;
      }

      const filename = this.generateFileName();
      const url = window.URL.createObjectURL(this.currentBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();

      // 清理URL
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);

      this.$Dialog.toast("开始下载");
    },

    // 获取试卷信息
    getExaminationInfo() {
      // 判断是否是随机组卷的,详情接口有区分
      if (this.isRandom) {
        this.$Api.examination
          .getRandomPaperDocument(this.paperDocumentId)
          .then((res) => {
            this.examinationInfo = res.data.data;
            this.getExamPaperInfo(res.data.data.paperId);
            // 获取试卷文件并预览
            this.loadPaperForPreview();
          })
          .catch(() => { });
      } else {
        this.$Api.examination
          .getExaminationInfo(this.paperDocumentId)
          .then((res) => {
            this.examinationInfo = res.data.data;
            this.getExamPaperInfo(res.data.data.paperId);
            // 获取试卷文件并预览
            this.loadPaperForPreview();
          })
          .catch(() => { });
      }
    },

    /**获取随机组卷信息 */
    // getRandomPaperDocument() {
    //   this.$Api.examination
    //     .getRandomPaperDocument(this.paperDocumentId)
    //     .then((res) => {
    //       this.examinationInfo = res.data.data;
    //       this.getExamPaperInfo(res.data.data.paperId);
    //       // 获取试卷文件并预览
    //       this.loadPaperForPreview();
    //     })
    //     .catch(() => {});
    // },

    // 获取试卷内容
    getExamPaperInfo(paperId) {
      this.loadPaper = this.$Dialog.loading("试卷内容获取中...");
      this.$Api.examination
        .getExamPaperInfo(paperId)
        .then((res) => {
          this.paperInfo = res.data.data;
          this.loadPaper.close();
        })
        .catch(() => {
          this.loadPaper.close();
        });
    },

    // 加载试卷文件用于预览
    async loadPaperForPreview() {
      this.loading = true;
      try {
        await this.downloadPaperForPreview();
      } catch (error) {
        console.error("加载试卷失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // 生成文件名
    generateFileName() {
      const baseName = this.paperInfo?.paperName || "试卷";
      const format = this.downloadPapams.format;
      const contents = [];

      if (this.downloadPapams.includeAnswer) contents.push("答案");
      if (this.downloadPapams.includeAnalysis) contents.push("解析");
      if (this.downloadPapams.includeExplanation) contents.push("分析");

      let suffix = "";
      if (contents.length > 0) {
        suffix = `_含${contents.join("")}`;
      }

      const cleanName = baseName.replace(/[<>:"/\\|?*]/g, "_");
      const fileExtension = format === "word" ? "docx" : format;
      return `${cleanName}${suffix}.${fileExtension}`;
    },

    // 切换全屏预览
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;

      if (this.isFullScreen) {
        document.documentElement.requestFullscreen?.();
      } else {
        document.exitFullscreen?.();
      }
    },

    // 监听全屏变化
    setupFullscreenListener() {
      document.addEventListener("fullscreenchange", () => {
        this.isFullScreen = !!document.fullscreenElement;
      });
    },

    // 下载Blob文件
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();

      // 清理URL
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);

      this.$Dialog.toast("开始下载");
    },

    // 试卷收藏/取消
    collectPaper() {
      if (this.examinationInfo.isCollection) {
        this.$Api.examination
          .cancelCollectPaper(this.examinationInfo.paperId)
          .then(() => {
            this.$Dialog.toast("取消成功");
            this.examinationInfo.isCollection = false;
          })
          .catch(() => { });
      } else {
        this.$Api.examination
          .collectPaper({ paperId: this.examinationInfo.paperId })
          .then(() => {
            this.$Dialog.toast("收藏成功");
            this.examinationInfo.isCollection = true;
          })
          .catch(() => { });
      }
    },
    // 修改 handleFileDownload 方法
    handleFileDownload(response, format) {
      return new Promise((resolve, reject) => {
        try {
          // 创建blob对象
          const blob = new Blob([response], {
            type:
              format === "pdf"
                ? "application/pdf"
                : "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          console.log(blob);

          // ========== 修改的部分开始 ==========
          // 1. 先保存blob对象以便后续上传
          this.fileBlob = blob;

          // 2. 创建预览URL（用于页面展示）
          const previewUrl = window.URL.createObjectURL(blob);
          this.previewFileUrl = previewUrl;

          // 3. 自动上传到服务器（如果需要）
          // this.uploadFileToServer(blob);

          // 4. 创建下载链接（如果需要立即下载）
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;

          // 设置文件名
          const fileName = this.generateFileName();
          link.download = fileName;

          // 添加到页面并触发下载
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);

          // 清理下载URL（预览URL保留）
          window.URL.revokeObjectURL(downloadUrl);
          // ========== 修改的部分结束 ==========

          resolve({ previewUrl, blob });
        } catch (error) {
          reject(error);
        }
      });
    },

    // 新增：上传文件到服务器的方法
    async uploadFileToServer(blob) {
      try {
        // 将Blob转换为File对象
        const fileName = this.generateFileName();
        const file = new File([blob], fileName, {
          type: blob.type,
          lastModified: Date.now(),
        });

        // 创建FormData对象
        const formData = new FormData();
        formData.append("file", file);
        formData.append("paperId", this.examinationInfo.paperId);
        formData.append("format", this.downloadPapams.format);

        // 上传文件
        const res = await this.$Api.common.uploadFile(formData);

        if (res.data && res.data.data) {
          // 保存服务器返回的文件URL
          this.serverFileUrl = res.data.data.url;
          console.log("文件上传成功，服务器路径:", this.serverFileUrl);

          // 如果需要，在这里触发页面更新
          this.$emit("file-uploaded", this.serverFileUrl);
        }
      } catch (error) {
        console.error("文件上传失败:", error);
      }
    },

    // 修改后的 downloadPaper 方法
    async downloadPaper() {
      this.downloadPapams.paperId = this.examinationInfo.paperId;
      const token = Cache.get("token");

      try {
        const response = await axios.post(
          Config.API_BASE_URL + "/yymCourseQuestionExamPaper/download",
          this.downloadPapams,
          {
            responseType: "blob",
            headers: {
              Authorization: `${token}`,
              "Content-Type": "application/json",
            },
            timeout: 30000,
          }
        );

        if (response.data instanceof Blob) {
          const blob = response.data;
          console.log(`文件大小: ${blob.size} 字节`);
          console.log(`文件类型: ${blob.type}`);

          // 生成文件名
          const filename = this.generateFileName();

          // 使用方法4的简化版下载
          this.simpleDownloadBlob(blob, filename);

          // 如果需要上传到服务器，可以取消注释
          // await this.uploadFileToServer(blob);
        }

        return response;
      } catch (error) {
        console.error("下载失败:", error);
        throw error;
      }
    },

    // 简单且安全的下载方法
    simpleDownloadBlob(blob, filename) {
      // 创建对象 URL
      const url = window.URL.createObjectURL(blob);

      // 创建下载链接
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      // 直接触发点击（现代浏览器支持）
      // link.click();

      // 清理 URL 对象
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);

      console.log(`开始下载: ${filename}`);
    },

    // 在线考试
    onlineExam() {
      //   this.href("/examPaper", {
      //     paperType: "examination",
      //     paperInfo: JSON.stringify(this.examinationInfo),
      //   });
      // 构建参数对象
      const params = {
        paperType: "examination",
        paperInfo: JSON.stringify(this.examinationInfo),
      };

      // 手动构建查询字符串（替代不存在的 objectToUrlParams 方法）
      const queryString = Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join("&");

      // 构建完整 URL（根据你的项目路由模式）
      // 你的项目使用的是 hash 模式（因为有 #/）
      const targetUrl = `/#/examPaper?${queryString}`;

      // 新窗口打开
      window.open(targetUrl, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.exam_paper_view {
  width: 100%;
  background: #f3f3f3;
  padding-top: 20px;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;

  .exam_paper_content {
    width: $pageMainWidth;

    .exam_paper_info {
      width: 848px;
      min-height: 700px;
      background: #ffffff;
      border-radius: 16px;
      box-sizing: border-box;
      padding: 25px;

      .exam_paper_info_top {
        border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

        .exam_paper_title {
          font-weight: 500;
          font-size: 18px;
          color: #303030;

          .back_icon {
            width: 22px;
            height: 22px;
          }

          .back_text {
            font-size: 14px;
            color: #13d6aa;
            margin-left: 7px;
          }
        }

        .exam_paper_data_total {
          .exam_paper_data {
            font-size: 14px;
            color: #606060;

            .data_one {
              z-index: 99;
              position: relative;

              .release_icon {
                width: 20px;
                height: 20px;
              }

              .more_box {
                position: absolute;
                width: 150px;
                background: #ffffff;
                box-shadow: 0px 0 14px 0px rgba(0, 0, 0, 0.06);
                border-radius: 11px;
                bottom: -95px;
                font-size: 14px;
                color: #606060;
              }
            }
          }

          .exam_paper_collect {
            font-size: 14px;
            color: #13d6aa;

            .release_icon {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .paper_right {
      .btn_buy {
        width: 330px;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(123deg, #ff854a 0%, #ff613d 100%);
        border-radius: 10px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        text-align: center;

        .paper_price {
          font-size: 20px;
        }
      }

      .btn_box {
        .btn_exam {
          width: 156px;
          height: 40px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #13d6aa;
          font-size: 14px;
          color: #13d6aa;
          text-align: center;
          line-height: 40px;
          box-sizing: border-box;
        }

        .btn_download {
          background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
          border: none;
          color: #ffffff;
        }
      }

      .recommend_paper {
        width: 330px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 16px;

        .recommend_one {
          .test_paper_cover_icon {
            width: 82px;
            flex-shrink: 0;
            // height: 80px;
          }

          .recommend_info {
            height: 80px;

            .recommend_title {
              font-weight: 500;
              font-size: 14px;
              color: #303030;
            }

            .recommend_info_content {
              font-weight: 500;
              font-size: 12px;
              color: #909090;
            }
          }
        }
      }
    }
  }

  .file-preview-container {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .preview-header {
      .preview-title {
        font-size: 16px;
        font-weight: 600;
        color: #303030;
      }

      .preview-action {
        font-size: 14px;
        color: #13d6aa;

        .download-icon,
        .fullscreen-icon {
          width: 16px;
          height: 16px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .pdf-preview,
    .word-preview,
    .image-preview {
      margin-top: 10px;

      .pdf-viewer,
      .word-viewer {
        width: 100%;
        height: 800px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;

        &.fullscreen {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 9999;
          background: #fff;
        }
      }

      .preview-image {
        max-width: 100%;
        max-height: 600px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
      }
    }
  }

  .loading-container {
    text-align: center;
    padding: 40px 0;
    color: #909090;

    .el-icon {
      color: #13d6aa;
    }
  }

  .preview-tip {
    background: #f0f9ff;
    border: 1px solid #d1ecff;
    border-radius: 4px;
    padding: 15px;

    .tip-icon {
      width: 20px;
      height: 20px;
    }

    .tip-content {
      color: #606060;
      font-size: 14px;
    }
  }

  .file-preview-container {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;

    .preview-header {
      .preview-title {
        font-size: 16px;
        font-weight: 600;
        color: #303030;
      }

      .preview-action {
        font-size: 14px;
        color: #13d6aa;
        cursor: pointer;

        .download-icon {
          width: 16px;
          height: 16px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .pdf-preview,
    .word-preview {
      margin-top: 10px;
      position: relative;

      .preview-mask {
        position: absolute;
        top: 500px;
        left: 0;
        right: 0;
        // bottom: -300px;
        background: rgba(255, 255, 255, 0.95);
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        opacity: 0.5;

        .mask-content {
          text-align: center;
          padding: 30px;

          .lock-icon {
            width: 60px;
            height: 60px;
          }

          .mask-title {
            font-size: 18px;
            font-weight: 600;
            color: #303030;
          }

          .mask-desc {
            font-size: 14px;
            color: #606060;
          }

          .mask-action {
            background: linear-gradient(123deg, #ff854a 0%, #ff613d 100%);
            color: white;
            padding: 10px 30px;
            border-radius: 10px;
            display: inline-block;
            cursor: pointer;
            font-size: 14px;
            transition: all 0.3s;

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(0, 212, 152, 0.3);
            }
          }
        }
      }

      .partial-preview {
        position: relative;
        height: 800px;
        overflow: hidden;
        border: 1px solid #e8e8e8;
        border-radius: 4px;

        .pdf-viewer.partial {
          width: 100%;
          height: 800px;
          transform: scale(0.8);
          transform-origin: top center;
          pointer-events: none;
        }

        .preview-placeholder {
          padding: 20px;
          background: white;

          .placeholder-header,
          .placeholder-footer {
            .placeholder-line {
              height: 20px;
              background: #f0f0f0;
              margin-bottom: 10px;
              border-radius: 4px;

              &.short {
                width: 60%;
              }
            }
          }

          .placeholder-content {
            margin: 20px 0;

            .placeholder-text {
              height: 16px;
              background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
              margin-bottom: 12px;
              border-radius: 2px;
              background-size: 200% 100%;
              animation: loading 1.5s infinite;

              &:nth-child(1) {
                width: 95%;
              }

              &:nth-child(2) {
                width: 85%;
              }

              &:nth-child(3) {
                width: 90%;
              }

              &:nth-child(4) {
                width: 80%;
              }

              &:nth-child(5) {
                width: 75%;
              }
            }
          }
        }

        .preview-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to bottom,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.3) 30%,
              rgba(255, 255, 255, 0.7) 60%,
              rgba(255, 255, 255, 0.95) 80%,
              rgba(255, 255, 255, 1) 100%);
          pointer-events: none;
        }
      }

      .pdf-viewer.full,
      .word-viewer.full {
        width: 100%;
        height: 800px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;

        &.fullscreen {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 9999;
          background: #fff;
        }
      }
    }

    .image-preview {
      position: relative;

      .preview-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.95);
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;

        // 蒙版样式同上
      }

      .preview-image {
        max-width: 100%;
        max-height: 600px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;

        &.blurred {
          filter: blur(10px);
          opacity: 0.6;
        }
      }
    }
  }

  .loading-container {
    text-align: center;
    padding: 40px 0;
    color: #909090;

    .el-icon {
      color: #13d6aa;
    }
  }

  .preview-tip {
    background: #f0f9ff;
    border: 1px solid #d1ecff;
    border-radius: 4px;
    padding: 15px;

    .tip-icon {
      width: 20px;
      height: 20px;
    }

    .tip-content {
      color: #606060;
      font-size: 14px;
    }
  }
}

// 加载动画
@keyframes loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

// 全屏模式下的样式
:fullscreen {
  .file-preview-container {
    padding: 0;
    border-radius: 0;

    .preview-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: #fff;
      z-index: 10000;
      padding: 10px 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
